import { useEffect, useCallback, useState } from 'react';
import { languageMap } from '../../maps/languageMap';
import { useActions, useLocker, useTypedSelector } from '../../hooks';
import { NavigationButton } from '../common';
import { Modal } from 'react-bootstrap';

const LockerHelper = () => {
  const [lockerConnected, setLockerConnected] = useState(false);
  const [setLocker] = useLocker();
  const { UpdateSettingUpLocker } = useActions();
  const language = useTypedSelector(({ session }) => {
    return session.language;
  });
  const logger = useTypedSelector(({ devices }) => {
    return devices.logger;
  });
  const locker = useTypedSelector(({ devices }) => {
    return devices.locker;
  });
  useEffect(() => {
    if (logger) {
      setLocker(logger);
    }
  }, [logger]);
  useEffect(() => {
    if (locker) {
      connectLocker();
    }
  }, [locker]);
  useEffect(() => {
    if (lockerConnected) {
      console.log('Finished setting up locker!');
      UpdateSettingUpLocker(false);
    }
  }, [lockerConnected, UpdateSettingUpLocker]);
  const connectLocker = async () => {
    if (locker && !locker.isConnected()) {
      addLockerEventListeners();
    }
  };
  //#region Locker Event Listeners
  const addLockerEventListeners = () => {
    locker?.addEventListener('connection', onLockerConnected);
    locker?.addEventListener('disconnection', onLockerDisconnected);
  };
  const onLockerConnected = useCallback(() => {
    console.log('se ha conectado');
    setLockerConnected(true);
  }, []);
  const onLockerDisconnected = useCallback(() => {
    console.log('se ha desconectado');
    setLockerConnected(false);
  }, []);
  return (
    <>
      <Modal
        show={!lockerConnected}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Conectando Lockers
          </Modal.Title>
        </Modal.Header>
      </Modal>
    </>
  );
};

export { LockerHelper };
